<mat-form-field
  class="w-full no-padding"
  appearance="outline"
  (click)="$event.stopPropagation()"
  [style.fontSize]="'10px'"
>
  <mat-label>Operator</mat-label>
  <mat-select [formControl]="operatorControl">
    <mat-option
      class="ag-custom-component-popup"
      *ngFor="let operator of operatorOptions ?? defaultOperatorOptions; trackBy: trackByValueProp"
      [value]="operator.value"
    >
      {{ operator.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
